import { AbstractControl, ValidatorFn } from '@angular/forms';
import { phonePatterns } from '@sc/data-access-models';

export class PhoneNumberValidator {
  static pattern(patternLangs?: string[]): ValidatorFn {
    const fn = (control: AbstractControl): { [key: string]: boolean } => {
      const value: string = control?.value
        ?.replace(/[^a-zA-Z\u0370-\u03FF0-9\+]/g, '')
        .toUpperCase();

      let patternsToCheck = [];

      if (patternLangs?.length > 0) {
        patternLangs.forEach((patternLang) => {
          if (phonePatterns[patternLang]) {
            patternsToCheck = patternsToCheck.concat(
              phonePatterns[patternLang]
            );
          }
        });
      }

      if (
        (value || new RegExp(/[\s]+/).test(control?.value)) &&
        patternsToCheck.length &&
        !PhoneNumberValidator.checkValue(value, patternsToCheck)
      ) {
        return { pattern: true };
      }

      return null;
    };

    return fn;
  }

  static checkValue(value: string, patternsToCheck: any[]): boolean {
    let valid = false;

    for (let i = 0; !valid && i < patternsToCheck.length; i++) {
      const pattern = patternsToCheck[i].pattern;
      if (new RegExp(pattern).test(value)) {
        valid = true;
      }
    }
    return valid;
  }
}
